import { getClearedCommercialPaymentPlanBookingFormPatch } from "./paymentPlanTorType";

export function clearPaymentPlanDraftOnLeaseTypeChange(
  bookingForm: Record<string, unknown>,
  previousTorType: string | undefined,
  nextTorType: string | undefined,
): Record<string, unknown> | null {
  if (!nextTorType || nextTorType === previousTorType) return null;

  return {
    ...bookingForm,
    torType: nextTorType,
    ...getClearedCommercialPaymentPlanBookingFormPatch(),
  };
}
